<template>
    <b-modal id="modalConferencia" title="Informar Conferência e Perfil" v-model="modal" hide-footer centered hide-header-close no-close-on-esc>
      <b-form ref="formularioConferencia" @submit.stop.prevent="continuar">
        <b-row class="mb-2">
          <b-col>
            <b-form-group label="Conferência: *" invalid-feedback="Selecionar uma conferência">
              <b-form-select v-model="form_selecao.conferencia_id" :options="conferencias" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Perfil: *" invalid-feedback="Selecionar um perfil">
              <b-form-select v-model="form_selecao.perfil_id" :options="perfis"/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-row no-gutters align-h="end">
              <b-button type="submit" variant="primary">
                <i class="fa fa-sign-in"/>&nbsp;&nbsp;Continuar
              </b-button>
            </b-row>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>    
</template>

<script>
import Vue from 'vue'
import miniToastr from 'mini-toastr'
import SessionStorage from '@/services/session-storage'

export default {
  name: 'ModalConferenciaPerfil',
  props: [],
  data: function () {
    return {
      form_selecao: {
        conferencia_id: null,
        perfil_id: null
      }
    }
  },
  created () {
    this.$store.dispatch('getConferenciasUser')
    this.$store.dispatch('configuracaoAtual')
  },
  computed: {
    modal () {
      return this.$store.state.conferencia.modal
    },
    conferencias () {
      return this.$store.state.usuario.conferencias
    },
    perfis () {
      return this.$store.state.usuario.perfisConferencia
    }
  },
  watch: {
    'form_selecao.conferencia_id': function () {
      this.$store.dispatch('getPerfisConferencia', this.form_selecao.conferencia_id)
    },
    'modal': function () {
      this.$bvModal.show('modalConferencia')
    },
  },
  methods: {
    continuar () {

      // Valida a seleção da conferência e do perfil
      if (!this.form_selecao.conferencia_id || !this.form_selecao.perfil_id) {
        this.$bvToast.toast('Informe a conferência e o perfil', {
          title: 'Falha',
          autoHideDelay: 10000,
          appendToast: true,
          variant: 'danger'
        })
        return false
      }

      // Atualiza os dados do perfil atual na sessão
      let perfil_atual_nome = null
      for(let x in this.perfis) {
        if(this.perfis[x].value == this.form_selecao.perfil_id){
          perfil_atual_nome = this.perfis[x].text
        }
      }

      SessionStorage.set('perfil_atual_nome', perfil_atual_nome)
      SessionStorage.set('perfil_atual_id', this.form_selecao.perfil_id)

      // Atualiza os dados da conferência atual na sessão
      Vue.http.get('api/conferencia/index/' + this.form_selecao.conferencia_id).then(response => {
        SessionStorage.set('conferencia_atual_id', response.data.data.id)
        SessionStorage.set('conferencia_atual_nome', response.data.data.nome)
        SessionStorage.set('conferencia_atual_sigla', response.data.data.sigla)
        SessionStorage.set('texto_apresentacao', response.data.data.texto_apresentacao)

        this.$store.dispatch('configuracaoAtual')
        
        // Atualiza o token e redireciona para a conferência
        Vue.http.put('api/auth/token/renovacao', {
          'perfil_atual_id' : this.form_selecao.perfil_id, 
          'conferencia_atual_id': this.form_selecao.conferencia_id
        }).then(response => {

          // Atualiza o token na session storage
          let token = response.data.data[0]
          SessionStorage.set('token', token)

          Vue.http.get('api/conferencia/index/' + this.form_selecao.conferencia_id).then(response => {
            this.$store.dispatch('setConferencia', {
              'conferencia_id': response.data.data.id,
              'conferencia_nome': response.data.data.nome
            })

            // TODO: Revisar necessidade
            Vue.http.post('api/configurarConferencia/buscar', {conferencia_id: this.form_selecao.conferencia_id}).then(response => {
              if (response.body.success && response.body.data.length > 0) {
                this.$store.dispatch('setConfigurarConferencia', response.body.data[0])
              }else{
                this.$store.dispatch('setConfigurarConferencia', {})
              }
              this.$store.dispatch('setModalConferencia', false)           
              this.$router.push({path: '/conferencia'})
              this.$router.go()
            })
          })          
        })      
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/ModalConferenciaPerfil.vue